import { findTarget } from '@shared/lib';

interface TargetSentenceProps {
  sentence: string;
  /** Где в предложении само слово: [начало, конец) символов (считает бэк). */
  spans?: Array<[number, number]>;
  /** Слово — по нему ищем выделение, если отрезков нет. */
  word: string;
  /** Класс выделенного слова. */
  markClassName: string;
}

/** Простое предложение со словом: слово выделено. Отрезков нет — ищем слово и его
 *  формы сами; не нашли — предложение без выделения. Сырой HTML не вставляем. */
export function TargetSentence({ sentence, spans = [], word, markClassName }: TargetSentenceProps) {
  let marks = spans.filter(([start, end]) => start >= 0 && end > start && end <= sentence.length);
  if (marks.length === 0 && word) {
    const found = findTarget(sentence, word);
    if (found) marks = [found];
  }
  const parts: Array<{ text: string; target: boolean }> = [];
  let cursor = 0;
  for (const [start, end] of marks) {
    if (start < cursor) continue;
    if (start > cursor) parts.push({ text: sentence.slice(cursor, start), target: false });
    parts.push({ text: sentence.slice(start, end), target: true });
    cursor = end;
  }
  if (cursor < sentence.length) parts.push({ text: sentence.slice(cursor), target: false });
  return (
    <>
      {parts.map((part, i) =>
        part.target ? (
          <span key={i} className={markClassName}>
            {part.text}
          </span>
        ) : (
          <span key={i}>{part.text}</span>
        ),
      )}
    </>
  );
}
